import reducers from './reducers';

export default reducers;

export { setEn, setEs } from './operations';
